/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import { Grid, Stack, useMediaQuery, Box, IconButton, Divider } from "@mui/material";
import _ from "lodash";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import {
	DEFAULT_CHART_DATA,
	DEFAULT_CHART_FILTER
} from "../../../data/common.data";
import { cardADTPatientChartData } from "../../../services/admission.service";
import { getAccountQuestions } from "../../../services/api/user.api";
import {
	closeADTDetailsDialog,
	setCachedMainResult,
	setCachedComparisonResult,
	clearCachedResults
} from "../../../store/reducers/admission.slice";
import { CHART_POINT_TYPE, CHART_TAB_BUTTON } from "../../../types/chart-dialog.type";
import { ADT_TABLE_TYPE, CHART_FILTER_DAY_OF, CUSTOM_TAB_TYPE, DASHBOARD_FILTER_TYPE, FILTER_TYPES } from "../../../types/common.type";
import {
	chartFilterPermission,
	chartGroupBy,
	chartsData,
	dayDifferent,
	getAdmissionADTFieldNames,
	isUpdateDefaultFilter
} from "../../../utilis/charts-common";
import ChartDetailsTab from "../../../components/shared/chart-dialog-common/ChartDetailsTab";
import ChartDialogContainer from "../../../components/shared/chart-dialog-common/ChartDialogContainer";
import ChartDialogLeftSidebar from "../../../components/shared/chart-dialog-common/ChartDialogLeftSidebar";
import ChartTabLoader from "../../../components/shared/chart-dialog-common/ChartTabLoader";
import ChartBuildingList from "../../../components/shared/chart-dialog-common/chart-building/ChartBuildingList";
import CardDetailChart from "../../../components/shared/chart-dialog-common/chart-tab/CardDetailChart";
import ChartTableList from "../../../components/shared/chart-dialog-common/chart-table/ChartTableList";
import AdtTransferViewFilter from "./viewTransferStatusOfAdmission/AdtTransferViewFilter";
import { PAGE_TYPE } from "../../../types/pages.type";
import ChartDetailsSearchBar from "../../../components/shared/chart-dialog-common/ChartDetailsSearchBar";
import { patientDataOrderBy, processCustomChartFiltersADT } from "../../../utilis/common";
import { filterPatientDataByLevel } from "../../../utilis/custom-tab-filter";
import NoteContainer from "../../../components/shared/NoteContainer";
import AdmissionHeaderFilterList from "./AdmissionHeaderFilterList";
import { HOSPITAL_CARDS_TYPE } from "../../../types/hospital.type";

const capitalizeFirstLetter = (str) => {
	if (!str || typeof str !== "string") return str;
	return str.charAt(0).toUpperCase() + str.slice(1);
};

const isAverageItem = (item) => {
	if (!item) return false;
	const key = item.key || item.id || item._id || "";
	const keyLower = typeof key === "string" ? key.toLowerCase() : "";
	return keyLower === "avarage" || keyLower === "average";
};

/** ADT list rows are transfers; combine totalByPage.patientIds may use transfer _id, admissionId, or patient._id (other dashboards). */
const registerAdtRowInCombineLookupMap = (map, row) => {
	if (!row || typeof row !== "object") return;
	const add = (v) => {
		if (v == null || v === "") return;
		const s = String(v);
		if (!map.has(s)) map.set(s, row);
	};
	add(row._id);
	add(row.id);
	add(row.admissionId);
	add(row.refPatientId);
	add(row.patientId);
	const p = row.patient;
	if (p && typeof p === "object") {
		add(p._id);
		add(p.id);
	}
};

const lookupAdtRowForCombineId = (map, mainData, idStr) => {
	const fromMap = map.get(idStr);
	if (fromMap) return fromMap;
	return mainData.find(
		(r) =>
			String(r._id) === idStr ||
			String(r.id) === idStr ||
			(r.admissionId != null && String(r.admissionId) === idStr) ||
			(r.refPatientId != null && String(r.refPatientId) === idStr) ||
			(r.patientId != null && String(r.patientId) === idStr) ||
			(r.patient?._id != null && String(r.patient._id) === idStr) ||
			(r.patient?.id != null && String(r.patient.id) === idStr)
	);
};

const resolveDiffDashboardForChart = (apiResponse, filtersObj) =>
	apiResponse?.diffDashboardPatients ??
	apiResponse?.customDiffrentDashboardData ??
	filtersObj?.customDiffrentDashboardData ??
	filtersObj?.diffDashboardPatients ??
	{};

/** ADT API nests list under data.list; filterPatientDataByLevel expects flat chart payload */
const mapSidebarRowIds = (items) =>
	(Array.isArray(items) ? items : [])
		.map((item) => item?._id ?? item?.id ?? item?.key)
		.filter((id) => id != null && id !== "");

const buildChartResponseFromAdtApi = (apiResponse, filtersObj) => ({
	data:
		apiResponse?.data?.list?.map((ele) => ({
			...ele,
			facilityName: ele?.facility?.name,
		})) ?? [],
	diffDashboardPatients: resolveDiffDashboardForChart(apiResponse, filtersObj),
	customCombineTabData: apiResponse?.customCombineTabData,
	ninetyDaysData: apiResponse?.data?.ninetyDaysData,
	sixtyDaysData: apiResponse?.data?.sixtyDaysData,
});

/** Scope chart rows to prior ADT custom/combine filters when opening a different ADT detail card */
const filterAdtChartPatientsByPriorCustomFilters = (patients, cardFilter, selectedCardItem) => {
	if (!Array.isArray(patients) || patients.length === 0) return patients;
	const priorCustomFilters = (cardFilter?.adtAdmitPatientIds || []).filter(
		(e) =>
			e?.type === ADT_TABLE_TYPE.CUSTOM &&
			!(
				e?.childId === selectedCardItem?.childId &&
				e?.cardId === selectedCardItem?.cardId
			)
	);
	if (priorCustomFilters.length === 0) return patients;

	return patients.filter((row) => {
		const rowId = String(row?._id ?? row?.id ?? "");
		const admissionId = row?.admissionId != null ? String(row.admissionId) : "";
		return priorCustomFilters.every((prior) => {
			const transferCandidates = [
				...(prior.transferIds || []),
				...(prior.patientIds || []),
				...(prior.selectedIds || []),
			].map((id) => String(id));
			const admissionCandidates = [
				...(prior.admissionIds || []),
				...(prior.ids || []),
			].map((id) => String(id));
			if (transferCandidates.length === 0 && admissionCandidates.length === 0) return true;
			return (
				(rowId && transferCandidates.includes(rowId)) ||
				(admissionId && admissionCandidates.includes(admissionId)) ||
				(admissionId && transferCandidates.includes(admissionId))
			);
		});
	});
};

const defaultFilter = {
	days: null,
	startDate: null,
	endDate: null,
	filterButtons: [],
	chartPointType: CHART_POINT_TYPE.TOTAL,
};

export default function AdmissionADTDetailsDialog({ handleOnClickReport, handleOnClickShareReport, handleGenerateExcelReport }) {
	const isMobileWidth = useMediaQuery('(max-width: 768px)');
	const isMobileLandscape = useMediaQuery('(max-height: 500px) and (max-width: 960px)');
	const isMobile = isMobileWidth || isMobileLandscape;
	const tableElementRef = useRef();
	const buildingElementRef = useRef();
	const activeRequestRef = useRef(null);
	const prevFiltersRef = useRef(null);
	const prevFiltersComparisonRef = useRef(null);
	const [selectedItem, setSelectedItem] = useState([]);
	const [isUpdateRefreshMemo, setIsUpdateRefreshMemo] = useState(false);
	const [loading, setLoading] = useState(false);
	const [buttonFilterType, setButtonFilterType] = useState(CHART_FILTER_DAY_OF.DAY);
	const [selectedCheckBoxItem, setSelectedCheckBoxItem] = useState([]);
	const [patientData, setPatientData] = useState([]);
	const [defaultChartData, setDefaultChartData] = useState([]);
	const [queryFilters, setQueryFilters] = useState(defaultFilter);

	const [defaultPatientData, setDefaultPatientData] = useState([]);
	const [filterData, setFilterData] = useState([]);
	const [chartData, setChartData] = useState([]);
	const [chartMainData, setChartMainData] = useState([]);
	const [dbAdmissionTotal, setDbAdmissionTotal] = useState(0);
	const dispatch = useDispatch();
	const [selectedFilter, setSelectedFilter] = useState(FILTER_TYPES.DAILY);
	const {
		filterTotal,
		detailsADTDialog: { isOpen, data, filters, dbData },
		lockedTotal, lockedTotalBy, lockeByADT,
		cardFilter
	} = useSelector((state) => state.admission);
	const [censusByFacility, setCensusByFacility] = useState([]);
	const [bedCapacityByFacility, setBedCapacityByFacility] = useState([]);

	// COMPARISON STATES ---------->
	const {
		detailsADTDialog: { data: dataComparison, filters: filtersComparison },
	} = useSelector((state) => state.admissionComparison);
	const [chartDataComparison, setChartDataComparison] = useState(DEFAULT_CHART_DATA);
	const [chartMainDataComparison, setChartMainDataComparison] = useState([]);
	const [dbAdmissionTotalComparison, setDbAdmissionTotalComparison] = useState(0);
	const [selectedCheckBoxItemComparison, setSelectedCheckBoxItemComparison] = useState([]);
	const [patientDataComparison, setPatientDataComparison] = useState([]);
	const [defaultChartDataComparison, setDefaultChartDataComparison] = useState([]);
	const [censusByFacilityComparison, setCensusByFacilityComparison] = useState([]);
	const [bedCapacityByFacilityComparison, setBedCapacityByFacilityComparison] = useState([]);
	const [queryFiltersComparison, setQueryFiltersComparison] = useState(DEFAULT_CHART_FILTER);
	const [defaultPatientDataComparison, setDefaultPatientDataComparison] = useState([]);
	const [filterDataComparison, setFilterDataComparison] = useState([]);
	const [selectedItemComparison, setSelectedItemComparison] = useState([]);
	const { auth } = useSelector(({ auth }) => ({ auth }));
	const [tableFilterType, setTableFilterType] = React.useState("all");
	const [defaultQuestions, setDefaultQuestions] = React.useState([]);
	const [questions, setQuestions] = React.useState([]);

	const [orderBy, setOrderBy] = useState('dateOfADT'); // Default sort column
	const [order, setOrder] = useState('asc'); // Default sort direction

	const activeFacilities = useSelector((state) => state.activeFacilities.facilities);

	const [selectedFacility, setSelectedFacility] = useState(activeFacilities);

	const [selectedTab, setSelectedTab] = useState(filters?.defaultTab ? filters?.defaultTab : CHART_TAB_BUTTON.TABLE);

	const { percentageBy } = useSelector((state) => state.common);
	// Mobile sidebar expand/collapse state
	const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

	const combineTabDataRef = useRef(null);
	const combineTabDataComparisonRef = useRef(null);
	const customDataArrayRef = useRef(null);
	const customDataArrayComparisonRef = useRef(null);
	const sidebarFilterDataRef = useRef([]);
	const sidebarFilterDataComparisonRef = useRef([]);

	const getQuestions = async (activeFacilitiesData, pageType) => {
		if (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
			setQuestions([]);
			return;
		}
		setQuestions([]);
		const res = await getAccountQuestions({
			facilityid: activeFacilitiesData,
			accountId: auth.accountId,
			pageType,
		});
		if (res && res.length > 0) {
			setDefaultQuestions(res);
		}
	};

	React.useEffect(() => {
		const handleUpdate = async (defaultQuestions) => {
			const filteredQuestions = filters.type.parentId === "communityTransfer" || filters.type.parentId === "overall"
				? tableFilterType === "all" ? [] : _.filter(defaultQuestions, { forTransferType: tableFilterType })
				: defaultQuestions;

			setQuestions(filteredQuestions);

			if (filteredQuestions !== defaultQuestions) {
				await Promise.all([
					filterOptions(selectedItem, defaultChartData, defaultChartData, buttonFilterType, { ...filters.filter, filterData: data, tableFilterType }, undefined, undefined, false),
					filterOptions(filtersComparison.selectedFilterData, defaultChartDataComparison, defaultChartDataComparison, buttonFilterType, { ...filtersComparison.filter, filterData: dataComparison, tableFilterType }, undefined, undefined, true),
				]);
			}
		};

		handleUpdate(defaultQuestions);
	}, [tableFilterType, defaultQuestions]); // eslint-disable-line

	React.useEffect(() => {
		getQuestions(activeFacilities, filters.type.parentId);
		// eslint-disable-next-line
	}, [activeFacilities]);

	// * added comparison
	const updateChartArrData = useCallback(
		async (dataArr, filterType = null, type = null, filterObj, forComparison) => {
			let filterBy = filterType;
			if (!filterBy) {
				filterBy = buttonFilterType;
			}
			let chartDataArr = [];
			if (type === "filter" && filterObj) {
				chartDataArr = await chartsData(dataArr, filterObj);
			} else {
				chartDataArr = await chartsData(dataArr, queryFilters);
			}
			let filtersLatest = filterObj ? filterObj : forComparison ? queryFiltersComparison : queryFilters;
			const latestChartData = await chartGroupBy(
				chartDataArr,
				filterBy,
				forComparison ? dbAdmissionTotalComparison : dbAdmissionTotal,
				[],
				filtersLatest
			);
			if (!forComparison) {
				setChartData(latestChartData);
			} else {
				setChartDataComparison(latestChartData);
			}
		},
		[buttonFilterType, dbAdmissionTotal, dbAdmissionTotalComparison, queryFilters, queryFiltersComparison]
	);

	// * added comparison
	const getPatientChartsData = async () => {
		const currentRequest = _.uniqueId();
		activeRequestRef.current = currentRequest;
		try {
			setLoading(true);

			const fetchPromises = [];
			fetchPromises.push(cardADTPatientChartData({ ...filters }, "main"));

			if (filtersComparison) {
				fetchPromises.push(cardADTPatientChartData({ ...filtersComparison }, "comparison"));
			} else {
				fetchPromises.push(Promise.resolve(null));
			}

			const [response, responseComparison] = await Promise.all(fetchPromises);

			if (activeRequestRef.current !== currentRequest) return;

			let responseData = [];
			let responseDataComparison = [];

			let latestButtonFilterType = buttonFilterType;
			const isUpdateFilter = isUpdateDefaultFilter(filters.filter);
			if (isUpdateFilter) {
				setSelectedFilter(FILTER_TYPES.WEEKLY);
				latestButtonFilterType = CHART_FILTER_DAY_OF.WEEK;
				setButtonFilterType(CHART_FILTER_DAY_OF.WEEK);
			}

			const adtPageType =
				filters?.type?.parentId || filters?.selectedCardItem?.parentId || PAGE_TYPE.ADMISSION;

			const chartResponseMain = buildChartResponseFromAdtApi(response, filters);
			const filteredMain = await filterPatientDataByLevel({
				response: chartResponseMain,
				filters,
				pageType: adtPageType,
			});
			responseData = filteredMain?.data ?? chartResponseMain.data ?? [];
			responseData = filterAdtChartPatientsByPriorCustomFilters(
				responseData,
				filters?.cardFilter,
				filters?.selectedCardItem
			);

			const isCombineQuestion = filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab;
			const isCustomTabQuestion =
				filters?.question?.isCustomTab &&
				filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.customTab;
			const mainPayload = response?.data ?? response;
			const combineRawMain = mainPayload?.customCombineTabData;
			const combineDataForSidebar =
				isCombineQuestion && Array.isArray(combineRawMain) && combineRawMain.length > 0
					? combineRawMain
					: isCombineQuestion && Array.isArray(data) && data.length > 0
						? data
						: null;

			let totalByPageFilterData = [];
			let skipFinalMainSetFilterDataToData = false;

			if (isCombineQuestion && combineDataForSidebar && combineDataForSidebar.length > 0) {
				const combineTabData = combineDataForSidebar[0];
				combineTabDataRef.current = combineTabData;
				skipFinalMainSetFilterDataToData = true;
				if (
					filters.question?.customTab?.isCustomDateAnalysis &&
					combineTabData?.customDataArray &&
					Array.isArray(combineTabData.customDataArray) &&
					combineTabData.customDataArray.length > 0
				) {
					customDataArrayRef.current = combineTabData.customDataArray;
					setFilterData(combineTabData.customDataArray);
				} else if (combineTabData?.totalByPage) {
					totalByPageFilterData = Object.keys(combineTabData.totalByPage).map((key) => {
						const pageData = combineTabData.totalByPage[key];
						const rawLabel = pageData.label || pageData.dashboard || key;
						const capitalizedLabel = capitalizeFirstLetter(rawLabel);
						return {
							_id: key,
							id: key,
							label: capitalizedLabel,
							name: capitalizedLabel,
							total: pageData.total || 0,
							value: pageData.total || 0,
							percentage: pageData.percentage || "0.0",
							patientIds: pageData.patientIds || [],
							dashboard: pageData.dashboard,
							originalTotal: pageData.total || 0,
							isTooltip: false,
						};
					});
					setFilterData(totalByPageFilterData);
				} else {
					setFilterData([]);
				}
			} else if (filters.question?.customTab?.isCustomDateAnalysis && filters?.customRangeCombinedData?.length > 0) {
				customDataArrayRef.current = filters.customRangeCombinedData;
				setFilterData(filters.customRangeCombinedData);
				skipFinalMainSetFilterDataToData = true;
			} else if (isCustomTabQuestion && Array.isArray(data) && data.length > 0) {
				setFilterData(data);
				skipFinalMainSetFilterDataToData = true;
			}

			let mainSidebarFilterData = data;
			if (
				filters?.question?.customTab?.isCustomDateAnalysis &&
				filters?.customRangeCombinedData?.length > 0
			) {
				mainSidebarFilterData = filters.customRangeCombinedData;
			} else if (
				isCombineQuestion &&
				customDataArrayRef.current &&
				Array.isArray(customDataArrayRef.current) &&
				customDataArrayRef.current.length > 0
			) {
				mainSidebarFilterData = customDataArrayRef.current;
			} else if (isCombineQuestion && totalByPageFilterData.length > 0) {
				mainSidebarFilterData = totalByPageFilterData;
			} else if (isCustomTabQuestion && Array.isArray(data) && data.length > 0) {
				mainSidebarFilterData = data;
			}
			sidebarFilterDataRef.current = mainSidebarFilterData;

			// Custom/combine: wait for sidebar filter before chart (avoids empty/wrong first paint).
			// Standard ADT (doctor, day, 90Days, GROUP): show chart immediately, then apply sidebar filter.
			const needsDeferredSidebarApply =
				isCombineQuestion ||
				isCustomTabQuestion ||
				!!filters?.question?.customTab?.isCustomDateAnalysis;
			const needsInitialSidebarFilter =
				needsDeferredSidebarApply ||
				(filters?.selectedFilterData && filters.selectedFilterData.length > 0) ||
				(Array.isArray(data) && data.length > 0);

			if (response && responseData.length > 0) {
				if (response.admissionTotal != null) {
					setDbAdmissionTotal(response.admissionTotal);
				}
				setDefaultPatientData(responseData);
				setDefaultChartData(responseData);
				if (response.censusByFacility) {
					setCensusByFacility(response?.censusByFacility || []);
				}
				if (response.bedCapacityByFacility) {
					setBedCapacityByFacility(response.bedCapacityByFacility);
				}
				setChartMainData(response?.data ?? response);

				if (!needsDeferredSidebarApply) {
					setPatientData(responseData);
					const chartDataArrData = await chartsData(responseData, filters.filter);
					const latestChartData = await chartGroupBy(
						chartDataArrData,
						latestButtonFilterType,
						response.admissionTotal ?? dbAdmissionTotal,
						[],
						queryFilters
					);
					setSelectedCheckBoxItem(responseData);
					setChartData(latestChartData);
				}
			}

			const filterObjMain = {
				...filters.filter,
				filterData: mainSidebarFilterData,
				tableFilterType,
			};

			const applyMainSidebarSelection = async () => {
				if (!responseData.length) return;

				if (filters.selectedFilterData && filters.selectedFilterData.length > 0) {
					let finalSelectedIds = [...filters.selectedFilterData];
					if (
						filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
						filters.question?.customTab?.isCustomDateAnalysis &&
						customDataArrayRef.current &&
						Array.isArray(customDataArrayRef.current) &&
						customDataArrayRef.current.length > 0
					) {
						const selectedAverageItems = filters.selectedFilterData.filter((selectedId) => {
							const item = customDataArrayRef.current.find(
								(it) => it._id === selectedId || it.id === selectedId || it.key === selectedId
							);
							return item !== undefined && isAverageItem(item);
						});
						const selectedRegularItems = filters.selectedFilterData.filter((selectedId) => {
							const item = customDataArrayRef.current.find(
								(it) => it._id === selectedId || it.id === selectedId || it.key === selectedId
							);
							return item !== undefined && !isAverageItem(item);
						});
						if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
							finalSelectedIds = selectedRegularItems;
						}
					} else if (
						filters.question?.customTab?.isCustomDateAnalysis &&
						filters?.customRangeCombinedData?.length > 0
					) {
						const selectedAverageItems = filters.selectedFilterData.filter((selectedId) => {
							const item = filters.customRangeCombinedData.find(
								(it) => it._id === selectedId || it.id === selectedId || it.key === selectedId
							);
							return item !== undefined && isAverageItem(item);
						});
						const selectedRegularItems = filters.selectedFilterData.filter((selectedId) => {
							const item = filters.customRangeCombinedData.find(
								(it) => it._id === selectedId || it.id === selectedId || it.key === selectedId
							);
							return item !== undefined && !isAverageItem(item);
						});
						if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
							finalSelectedIds = selectedRegularItems;
						}
					}

					setSelectedItem(finalSelectedIds);
					await filterOptions(
						finalSelectedIds,
						responseData,
						responseData,
						latestButtonFilterType,
						filterObjMain
					);
				} else if (isCombineQuestion) {
					if (
						filters.question?.customTab?.isCustomDateAnalysis &&
						customDataArrayRef.current &&
						Array.isArray(customDataArrayRef.current) &&
						customDataArrayRef.current.length > 0
					) {
						const averageItems = customDataArrayRef.current.filter((item) => isAverageItem(item));
						const regularItems = customDataArrayRef.current.filter((item) => !isAverageItem(item));
						let selectedIds = [];
						if (regularItems.length > 0) {
							selectedIds = mapSidebarRowIds(regularItems);
						} else if (averageItems.length > 0) {
							selectedIds = mapSidebarRowIds(averageItems);
						}
						setSelectedItem(selectedIds);
						if (selectedIds.length > 0) {
							await filterOptions(
								selectedIds,
								responseData,
								responseData,
								latestButtonFilterType,
								filterObjMain
							);
						}
					} else {
						const selectedIds = mapSidebarRowIds(totalByPageFilterData);
						setSelectedItem(selectedIds);
						if (selectedIds.length > 0) {
							await filterOptions(
								selectedIds,
								responseData,
								responseData,
								latestButtonFilterType,
								filterObjMain
							);
						}
					}
				} else if (
					filters.question?.customTab?.isCustomDateAnalysis &&
					filters?.customRangeCombinedData?.length > 0
				) {
					const averageItems = filters.customRangeCombinedData.filter((item) => isAverageItem(item));
					const regularItems = filters.customRangeCombinedData.filter((item) => !isAverageItem(item));
					let selectedIds = [];
					if (regularItems.length > 0) {
						selectedIds = mapSidebarRowIds(regularItems);
					} else if (averageItems.length > 0) {
						selectedIds = mapSidebarRowIds(averageItems);
					}
					setSelectedItem(selectedIds);
					if (selectedIds.length > 0) {
						await filterOptions(
							selectedIds,
							responseData,
							responseData,
							latestButtonFilterType,
							filterObjMain
						);
					}
				} else if (Array.isArray(data) && data.length > 0) {
					const selectedIds = mapSidebarRowIds(data);
					setSelectedItem(selectedIds);
					if (selectedIds.length > 0) {
						await filterOptions(
							selectedIds,
							responseData,
							responseData,
							latestButtonFilterType,
							filterObjMain
						);
					}
				} else {
					const cardType = filters?.selectedCardItem?.type;
					if (cardType === ADT_TABLE_TYPE.ALL || cardType === ADT_TABLE_TYPE.TOTAL) {
						setPatientData(responseData);
						setSelectedCheckBoxItem(responseData);
						const chartDataArrData = await chartsData(responseData, filters.filter);
						const latestChartData = await chartGroupBy(
							chartDataArrData,
							latestButtonFilterType,
							response.admissionTotal ?? dbAdmissionTotal,
							[],
							queryFilters
						);
						setChartData(latestChartData);
					}
				}
			};

			if (needsInitialSidebarFilter && responseData.length > 0) {
				await new Promise((resolve) => {
					setTimeout(() => {
						applyMainSidebarSelection().finally(resolve);
					}, 0);
				});
			}

			if (!skipFinalMainSetFilterDataToData) {
				setFilterData(data);
			}

			// COMPARISON BLOCK
			const adtPageTypeComparison =
				filtersComparison?.type?.parentId ||
				filtersComparison?.selectedCardItem?.parentId ||
				PAGE_TYPE.ADMISSION;

			if (responseComparison?.data?.list?.length > 0) {
				const chartResponseComparison = buildChartResponseFromAdtApi(responseComparison, filtersComparison);
				const filteredComparison = await filterPatientDataByLevel({
					responseComparison: chartResponseComparison,
					filters: filtersComparison,
					pageType: adtPageTypeComparison,
					forComparison: true,
				});
				responseDataComparison = filteredComparison?.data ?? chartResponseComparison.data ?? [];
				responseDataComparison = filterAdtChartPatientsByPriorCustomFilters(
					responseDataComparison,
					filtersComparison?.cardFilter,
					filtersComparison?.selectedCardItem
				);
			}

			const isCombineQuestionComp = filtersComparison?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab;
			const isCustomTabQuestionComp =
				filtersComparison?.question?.isCustomTab &&
				filtersComparison?.question?.customTab?.type === CUSTOM_TAB_TYPE.customTab;
			const compPayload = responseComparison?.data ?? responseComparison;
			const combineRawComp = compPayload?.customCombineTabData;
			const combineDataForSidebarComp =
				isCombineQuestionComp && Array.isArray(combineRawComp) && combineRawComp.length > 0
					? combineRawComp
					: isCombineQuestionComp && Array.isArray(dataComparison) && dataComparison.length > 0
						? dataComparison
						: null;

			let totalByPageFilterDataComparison = [];
			let skipFinalComparisonSetFilterDataToData = false;

			if (isCombineQuestionComp && combineDataForSidebarComp && combineDataForSidebarComp.length > 0) {
				const combineTabDataComparison = combineDataForSidebarComp[0];
				combineTabDataComparisonRef.current = combineTabDataComparison;
				skipFinalComparisonSetFilterDataToData = true;
				if (
					filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
					combineTabDataComparison?.customDataArray &&
					Array.isArray(combineTabDataComparison.customDataArray) &&
					combineTabDataComparison.customDataArray.length > 0
				) {
					customDataArrayComparisonRef.current = combineTabDataComparison.customDataArray;
					setFilterDataComparison(combineTabDataComparison.customDataArray);
				} else if (combineTabDataComparison?.totalByPage) {
					totalByPageFilterDataComparison = Object.keys(combineTabDataComparison.totalByPage).map((key) => {
						const pageData = combineTabDataComparison.totalByPage[key];
						const rawLabel = pageData.label || pageData.dashboard || key;
						const capitalizedLabel = capitalizeFirstLetter(rawLabel);
						return {
							_id: key,
							id: key,
							label: capitalizedLabel,
							name: capitalizedLabel,
							total: pageData.total || 0,
							value: pageData.total || 0,
							percentage: pageData.percentage || "0.0",
							patientIds: pageData.patientIds || [],
							dashboard: pageData.dashboard,
							originalTotal: pageData.total || 0,
							isTooltip: false,
						};
					});
					setFilterDataComparison(totalByPageFilterDataComparison);
				} else {
					setFilterDataComparison([]);
				}
			} else if (
				filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
				filtersComparison?.customRangeCombinedData?.length > 0
			) {
				customDataArrayComparisonRef.current = filtersComparison.customRangeCombinedData;
				setFilterDataComparison(filtersComparison.customRangeCombinedData);
				skipFinalComparisonSetFilterDataToData = true;
			} else if (isCustomTabQuestionComp && Array.isArray(dataComparison) && dataComparison.length > 0) {
				setFilterDataComparison(dataComparison);
				skipFinalComparisonSetFilterDataToData = true;
			}

			let comparisonSidebarFilterData = dataComparison;
			if (
				filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
				filtersComparison?.customRangeCombinedData?.length > 0
			) {
				comparisonSidebarFilterData = filtersComparison.customRangeCombinedData;
			} else if (
				isCombineQuestionComp &&
				customDataArrayComparisonRef.current &&
				Array.isArray(customDataArrayComparisonRef.current) &&
				customDataArrayComparisonRef.current.length > 0
			) {
				comparisonSidebarFilterData = customDataArrayComparisonRef.current;
			} else if (isCombineQuestionComp && totalByPageFilterDataComparison.length > 0) {
				comparisonSidebarFilterData = totalByPageFilterDataComparison;
			} else if (isCustomTabQuestionComp && Array.isArray(dataComparison) && dataComparison.length > 0) {
				comparisonSidebarFilterData = dataComparison;
			}
			sidebarFilterDataComparisonRef.current = comparisonSidebarFilterData;

			const needsDeferredSidebarApplyComp =
				isCombineQuestionComp ||
				isCustomTabQuestionComp ||
				!!filtersComparison?.question?.customTab?.isCustomDateAnalysis;
			const needsInitialSidebarFilterComp =
				needsDeferredSidebarApplyComp ||
				(filtersComparison?.selectedFilterData && filtersComparison.selectedFilterData.length > 0) ||
				(Array.isArray(dataComparison) && dataComparison.length > 0);

			if (responseDataComparison.length > 0) {
				if (responseComparison?.admissionTotal != null) {
					setDbAdmissionTotalComparison(responseComparison.admissionTotal);
				}
				setDefaultPatientDataComparison(responseDataComparison);
				setDefaultChartDataComparison(responseDataComparison);
				if (responseComparison?.censusByFacility) {
					setCensusByFacilityComparison(responseComparison?.censusByFacility || []);
				}
				if (responseComparison?.bedCapacityByFacility) {
					setBedCapacityByFacilityComparison(responseComparison.bedCapacityByFacility);
				}
				setChartMainDataComparison(responseComparison?.data ?? responseComparison);

				if (!needsDeferredSidebarApplyComp) {
					setPatientDataComparison(responseDataComparison);
					const chartDataArrDataComparison = await chartsData(
						responseDataComparison,
						filtersComparison?.filter
					);
					const latestChartDataComparison = await chartGroupBy(
						chartDataArrDataComparison,
						latestButtonFilterType,
						responseComparison?.admissionTotal ?? dbAdmissionTotalComparison,
						[],
						queryFiltersComparison
					);
					setSelectedCheckBoxItemComparison(responseDataComparison);
					setChartDataComparison(latestChartDataComparison);
				}
			}

			const filterObjComparison = {
				...filtersComparison?.filter,
				filterData: comparisonSidebarFilterData,
				tableFilterType,
			};

			const comparisonList = responseDataComparison.length > 0 ? responseDataComparison : null;

			const applyComparisonSidebarSelection = async () => {
				if (!comparisonList) return;

			if (
				filtersComparison?.selectedFilterData &&
				filtersComparison?.selectedFilterData.length > 0 &&
				comparisonList
			) {
				let finalSelectedIdsComparison = [...filtersComparison.selectedFilterData];
				if (
					filtersComparison?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
					filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
					customDataArrayComparisonRef.current &&
					Array.isArray(customDataArrayComparisonRef.current) &&
					customDataArrayComparisonRef.current.length > 0
				) {
					const selectedAverageItems = filtersComparison.selectedFilterData.filter((selectedId) => {
						const item = customDataArrayComparisonRef.current.find(
							(it) =>
								(it._id === selectedId || it.id === selectedId || it.key === selectedId) &&
								isAverageItem(it)
						);
						return item !== undefined;
					});
					const selectedRegularItems = filtersComparison.selectedFilterData.filter((selectedId) => {
						const item = customDataArrayComparisonRef.current.find(
							(it) =>
								(it._id === selectedId || it.id === selectedId || it.key === selectedId) &&
								!isAverageItem(it)
						);
						return item !== undefined;
					});
					if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
						finalSelectedIdsComparison = selectedRegularItems;
					}
				} else if (
					filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
					filtersComparison?.customRangeCombinedData?.length > 0
				) {
					const selectedAverageItems = filtersComparison.selectedFilterData.filter((selectedId) => {
						const item = filtersComparison.customRangeCombinedData.find(
							(it) =>
								(it._id === selectedId || it.id === selectedId || it.key === selectedId) &&
								isAverageItem(it)
						);
						return item !== undefined;
					});
					const selectedRegularItems = filtersComparison.selectedFilterData.filter((selectedId) => {
						const item = filtersComparison.customRangeCombinedData.find(
							(it) =>
								(it._id === selectedId || it.id === selectedId || it.key === selectedId) &&
								!isAverageItem(it)
						);
						return item !== undefined;
					});
					if (selectedAverageItems.length > 0 && selectedRegularItems.length > 0) {
						finalSelectedIdsComparison = selectedRegularItems;
					}
				}

				setSelectedItemComparison(finalSelectedIdsComparison);
				await filterOptions(
					finalSelectedIdsComparison,
					comparisonList,
					comparisonList,
					latestButtonFilterType,
					filterObjComparison,
					undefined,
					undefined,
					true
				);
			} else if (isCombineQuestionComp && comparisonList) {
				if (
					filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
					customDataArrayComparisonRef.current &&
					Array.isArray(customDataArrayComparisonRef.current) &&
					customDataArrayComparisonRef.current.length > 0
				) {
					const averageItems = customDataArrayComparisonRef.current.filter((item) => isAverageItem(item));
					const regularItems = customDataArrayComparisonRef.current.filter((item) => !isAverageItem(item));
					let selectedIdsComparison = [];
					if (regularItems.length > 0) {
						selectedIdsComparison = mapSidebarRowIds(regularItems);
					} else if (averageItems.length > 0) {
						selectedIdsComparison = mapSidebarRowIds(averageItems);
					}
					setSelectedItemComparison(selectedIdsComparison);
					if (selectedIdsComparison.length > 0) {
						await filterOptions(
							selectedIdsComparison,
							comparisonList,
							comparisonList,
							latestButtonFilterType,
							filterObjComparison,
							undefined,
							undefined,
							true
						);
					}
				} else {
					const selectedIdsComparison = mapSidebarRowIds(totalByPageFilterDataComparison);
					setSelectedItemComparison(selectedIdsComparison);
					if (selectedIdsComparison.length > 0) {
						await filterOptions(
							selectedIdsComparison,
							comparisonList,
							comparisonList,
							latestButtonFilterType,
							filterObjComparison,
							undefined,
							undefined,
							true
						);
					}
				}
			} else if (
				filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
				filtersComparison?.customRangeCombinedData?.length > 0
			) {
				const averageItems = filtersComparison.customRangeCombinedData.filter((item) => isAverageItem(item));
				const regularItems = filtersComparison.customRangeCombinedData.filter((item) => !isAverageItem(item));
				let selectedIds = [];
				if (regularItems.length > 0) {
					selectedIds = mapSidebarRowIds(regularItems);
				} else if (averageItems.length > 0) {
					selectedIds = mapSidebarRowIds(averageItems);
				}
				setSelectedItemComparison(selectedIds);
				if (selectedIds.length > 0) {
					await filterOptions(
						selectedIds,
						comparisonList,
						comparisonList,
						latestButtonFilterType,
						filterObjComparison,
						undefined,
						undefined,
						true
					);
				}
			} else if (Array.isArray(dataComparison) && dataComparison.length > 0) {
				const selectedIdsComparison = mapSidebarRowIds(dataComparison);
				setSelectedItemComparison(selectedIdsComparison);
				if (selectedIdsComparison.length > 0) {
					await filterOptions(
						selectedIdsComparison,
						comparisonList,
						comparisonList,
						latestButtonFilterType,
						filterObjComparison,
						undefined,
						undefined,
						true
					);
				}
			}
			};

			if (needsInitialSidebarFilterComp && comparisonList) {
				await new Promise((resolve) => {
					setTimeout(() => {
						applyComparisonSidebarSelection().finally(resolve);
					}, 0);
				});
			}

			if (!skipFinalComparisonSetFilterDataToData) {
				setFilterDataComparison(dataComparison);
			}
		} catch {
			// ignore load errors; UI stays in previous state
		} finally {
			if (activeRequestRef.current === currentRequest) {
				setLoading(false);
			}
		}
	};

	// * added comparison
	const reset = () => {
		setSelectedItem([]);
		setPatientData([]);
		setDefaultPatientData([]);
		setFilterData([]);

		setSelectedItemComparison([]);
		setPatientDataComparison([]);
		setDefaultPatientDataComparison([]);
		setFilterDataComparison([]);

		combineTabDataRef.current = null;
		combineTabDataComparisonRef.current = null;
		customDataArrayRef.current = null;
		customDataArrayComparisonRef.current = null;
		sidebarFilterDataRef.current = [];
		sidebarFilterDataComparisonRef.current = [];
	};

	// * added comparison
	const filterByCheckbox = useCallback(
		async (filter = null, isAllChecked = false, dataFilters, forComparison) => {
			if (forComparison) {
				// COMPARISON BLOCK
				const {
					arrData: arrDataComparison,
					chartData: chartDataComparison,
					latestButtonFilterType: latestButtonFilterTypeComparison,
					filterObj: filterObjComparison,
				} = dataFilters;
				if (isAllChecked) {
					setPatientDataComparison(arrDataComparison);
					setSelectedCheckBoxItemComparison(chartDataComparison);
					await updateChartArrData(
						chartDataComparison,
						latestButtonFilterTypeComparison,
						"filter",
						filterObjComparison,
						forComparison
					);
				} else {
					let newFiltersComparison = _.filter(arrDataComparison, filter);
					setPatientDataComparison(newFiltersComparison);
					let newChartFiltersComparison = _.filter(chartDataComparison, filter);
					setSelectedCheckBoxItemComparison(newChartFiltersComparison);
					await updateChartArrData(
						newChartFiltersComparison,
						latestButtonFilterTypeComparison,
						"filter",
						filterObjComparison,
						forComparison
					);
				}
			} else {
				const { arrData, chartData, latestButtonFilterType, filterObj } = dataFilters;
				if (isAllChecked) {
					setPatientData(arrData);
					setSelectedCheckBoxItem(chartData);
					await updateChartArrData(chartData, latestButtonFilterType, "filter", filterObj);
				} else {
					let newFilters = _.filter(arrData, filter);

					setPatientData(newFilters);
					let newChartFilters = _.filter(chartData, filter);
					setSelectedCheckBoxItem(newChartFilters);
					await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj);
				}
			}
		},
		[updateChartArrData]
	);

	// * added comparison - but if anything wrong, check here first.
	const filterOptions = async (
		newChecked,
		mainDataArr = [],
		chartDataArr,
		latestButtonFilterType = null,
		filterObj,
		filterType = "initial",
		originalData,
		forComparison
	) => {
		const { childId, type } = filters.selectedCardItem;
		let arrData = mainDataArr;
		let chartData = chartDataArr
		const tableFilterType = filterObj?.tableFilterType;

		if (tableFilterType === "admission" || tableFilterType === "readmission") {
			arrData = _.filter(arrData, ({ type }) => _.includes(["admission", "readmission"], type));
		} else if (tableFilterType === "hospitalTransfer") {
			arrData = _.filter(arrData, ({ transferType }) => _.includes([HOSPITAL_CARDS_TYPE.PLANNED, HOSPITAL_CARDS_TYPE.UNPLANNED], transferType));
		} else if (tableFilterType === "safeDischarge" || tableFilterType === "SNF" || tableFilterType === "AMA" || tableFilterType === "deceased") {
			arrData = _.filter(arrData, ({ transferType }) => _.includes([tableFilterType], transferType));
		}

		if (activeFacilities.length > 1) {
			const filterPatientsByFacility = _.filter(arrData, ({ facilityId }) => _.every([_.includes(selectedFacility, facilityId)]));
			arrData = filterPatientsByFacility;
		}

		const isCombineTab = filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab;
		if (isCombineTab) {
			let mainData = forComparison
				? defaultPatientDataComparison.length > 0
					? defaultPatientDataComparison
					: mainDataArr
				: defaultPatientData.length > 0
					? defaultPatientData
					: mainDataArr;

			if (tableFilterType === "admission" || tableFilterType === "readmission") {
				mainData = _.filter(mainData, ({ type }) => _.includes(["admission", "readmission"], type));
			} else if (tableFilterType === "hospitalTransfer") {
				mainData = _.filter(mainData, ({ transferType }) =>
					_.includes([HOSPITAL_CARDS_TYPE.PLANNED, HOSPITAL_CARDS_TYPE.UNPLANNED], transferType)
				);
			} else if (
				tableFilterType === "safeDischarge" ||
				tableFilterType === "SNF" ||
				tableFilterType === "AMA" ||
				tableFilterType === "deceased"
			) {
				mainData = _.filter(mainData, ({ transferType }) => _.includes([tableFilterType], transferType));
			}
			if (activeFacilities.length > 1) {
				mainData = _.filter(mainData, ({ facilityId }) => _.every([_.includes(selectedFacility, facilityId)]));
			}

			const isCustomDateAnalysisCombineTab = filters.question?.customTab?.isCustomDateAnalysis;
			const customDataArray = forComparison ? customDataArrayComparisonRef.current : customDataArrayRef.current;

			const applyCombinePatientRows = async (newChartFilters) => {
				if (forComparison) {
					setPatientDataComparison(newChartFilters);
					setSelectedCheckBoxItemComparison(newChartFilters);
					await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
				} else {
					setPatientData(newChartFilters);
					setSelectedCheckBoxItem(newChartFilters);
					await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
				}
			};

			if (isCustomDateAnalysisCombineTab && customDataArray && Array.isArray(customDataArray) && customDataArray.length > 0) {
				if (newChecked.length > 0) {
					let combinedPatientIds = [];
					newChecked.forEach((selectedId) => {
						const customDataItem = customDataArray.find(
							(item) => item._id === selectedId || item.id === selectedId || item.key === selectedId
						);
						if (
							customDataItem &&
							customDataItem.patientIds &&
							Array.isArray(customDataItem.patientIds) &&
							customDataItem.patientIds.length > 0
						) {
							combinedPatientIds = [
								...combinedPatientIds,
								...customDataItem.patientIds.map((id) => String(id)),
							];
						}
					});
					if (combinedPatientIds.length > 0) {
						const patientMap = new Map();
						mainData.forEach((patient) => registerAdtRowInCombineLookupMap(patientMap, patient));
						let newChartFilters = [];
						combinedPatientIds.forEach((patientId) => {
							const patient = lookupAdtRowForCombineId(patientMap, mainData, patientId);
							if (patient) newChartFilters.push(patient);
						});
						await applyCombinePatientRows(newChartFilters);
					} else {
						await applyCombinePatientRows([]);
					}
				} else {
					await applyCombinePatientRows([]);
				}
				return;
			}

			const combineTabData = forComparison ? combineTabDataComparisonRef.current : combineTabDataRef.current;
			if (combineTabData?.totalByPage && newChecked.length > 0) {
				let combinedPatientIds = [];
				newChecked.forEach((selectedKey) => {
					const pageData = combineTabData.totalByPage[selectedKey];
					if (pageData && pageData.patientIds && Array.isArray(pageData.patientIds) && pageData.patientIds.length > 0) {
						combinedPatientIds = [...combinedPatientIds, ...pageData.patientIds.map((id) => String(id))];
					}
				});
				if (combinedPatientIds.length > 0) {
					const patientMap = new Map();
					mainData.forEach((patient) => registerAdtRowInCombineLookupMap(patientMap, patient));
					let newChartFilters = [];
					combinedPatientIds.forEach((patientId) => {
						const patient = lookupAdtRowForCombineId(patientMap, mainData, patientId);
						if (patient) newChartFilters.push(patient);
					});
					await applyCombinePatientRows(newChartFilters);
				} else {
					await applyCombinePatientRows([]);
				}
			} else {
				await applyCombinePatientRows([]);
			}
			return;
		}

		if (childId === "reHospitalization") {
			if (newChecked.length === 1) {
				let filterDataObj = Object();
				filterDataObj.reHospitalization = newChecked[0] == "newHospitalizations" ? false : true;
				await filterByCheckbox(
					filterDataObj,
					false,
					{ arrData, chartData, latestButtonFilterType, filterObj },
					forComparison
				);
			} else {
				await filterByCheckbox(null, true, { arrData, chartData, latestButtonFilterType, filterObj }, forComparison);
			}
		}
		if (childId === "wasAdmitted") {
			if (newChecked.length === 1) {
				let filterDataObj = Object();
				filterDataObj.wasAdmitted = newChecked[0] === "DC" ? true : false;
				await filterByCheckbox(
					filterDataObj,
					false,
					{ arrData, chartData, latestButtonFilterType, filterObj },
					forComparison
				);
			} else {
				await filterByCheckbox(null, true, { arrData, chartData, latestButtonFilterType, filterObj }, forComparison);
			}
		}
		if (childId === "wasReturned") {
			if (newChecked.length === 1) {
				let filterDataObj = Object();
				filterDataObj.wasReturned = newChecked[0] === "returned" ? true : false;
				await filterByCheckbox(
					filterDataObj,
					false,
					{ arrData, chartData, latestButtonFilterType, filterObj },
					forComparison
				);
			} else {
				await filterByCheckbox(null, true, { arrData, chartData, latestButtonFilterType, filterObj }, forComparison);
			}
		}
		if (childId === "day") {
			let newFilters = _.filter(arrData, ({ day }) => {
				return _.every([_.includes(newChecked, day)]);
			});
			forComparison ? setPatientDataComparison(newFilters) : setPatientData(newFilters);
			let newChartFilters = _.filter(chartData, ({ day }) => {
				return _.every([_.includes(newChecked, day)]);
			});
			forComparison ? setSelectedCheckBoxItemComparison(newChartFilters) : setSelectedCheckBoxItem(newChartFilters);
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
		}
		if (childId === "shiftName") {
			let newFilters = _.filter(arrData, ({ shiftName }) => {
				return _.every([_.includes(newChecked, shiftName)]);
			});
			forComparison ? setPatientDataComparison(newFilters) : setPatientData(newFilters);
			let newChartFilters = _.filter(chartData, ({ shiftName }) => {
				return _.every([_.includes(newChecked, shiftName)]);
			});
			forComparison ? setSelectedCheckBoxItemComparison(newChartFilters) : setSelectedCheckBoxItem(newChartFilters);
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
		}
		if (childId === "90Days" || childId === "60Days" || childId === "90DaysDeceased" || childId === "90DaysOverall") {
			let ninetyDaysDataIds = [];
			let filterDataObj = filterData;
			if (filterDataObj.length == 0) {
				if (childId === "90Days") {
					filterDataObj = chartMainData.ninetyDaysData;
				}
				if (childId === "60Days") {
					filterDataObj = chartMainData.sixtyDaysData;
				}
				if (childId === "90DaysDeceased") {
					filterDataObj = chartMainData.deceasedNinetyDaysChartCountData;
				}
				if (childId === "90DaysOverall") {
					filterDataObj = chartMainData.overAllNinetyDaysChartCountData;
				}
			}
			let dataOriginal = filterObj?.filterData ? filterObj.filterData : filterDataObj;
			if (filterType === "reload") {
				if (childId === "90Days") {
					dataOriginal = originalData.ninetyDaysData;
				}
				if (childId === "60Days") {
					dataOriginal = originalData.sixtyDaysData;
				}
				if (childId === "90DaysDeceased") {
					dataOriginal = originalData.deceasedNinetyDaysChartCountData;
				}
				if (childId === "90DaysOverall") {
					dataOriginal = originalData.overAllNinetyDaysChartCountData;
				}
			}
			let ninetyDaysDataFilter = _.filter(dataOriginal, ({ _id }) => _.every([_.includes(newChecked, _id)]));

			if (ninetyDaysDataFilter && ninetyDaysDataFilter.length > 0) {
				ninetyDaysDataFilter.map((item) => (ninetyDaysDataIds = [...ninetyDaysDataIds, ...item.ids]));
			}

			let newFilters = _.filter(arrData, ({ _id }) => _.every([_.includes(ninetyDaysDataIds, _id)]));
			forComparison ? setPatientDataComparison(newFilters) : setPatientData(newFilters);
			let newChartFilters = _.filter(chartData, ({ _id }) => _.every([_.includes(ninetyDaysDataIds, _id)]));
			forComparison ? setSelectedCheckBoxItemComparison(newChartFilters) : setSelectedCheckBoxItem(newChartFilters);
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
		}

		if (type === ADT_TABLE_TYPE.CUSTOM) {
			const filterDataArr = filterObj?.filterData ? filterObj?.filterData : filterData;
			const isCustomTab =
				filters?.question?.isCustomTab &&
				filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.customTab;
			const customBaseData = forComparison
				? defaultPatientDataComparison.length > 0
					? defaultPatientDataComparison
					: arrData
				: defaultPatientData.length > 0
					? defaultPatientData
					: arrData;
			const customChartBase = isCustomTab ? customBaseData : chartData;

			let newFilters = await processCustomChartFiltersADT(
				customBaseData,
				filters,
				newChecked,
				filterDataArr
			);

			forComparison ? setPatientDataComparison(newFilters) : setPatientData(newFilters);

			let newChartFilters = await processCustomChartFiltersADT(
				customChartBase,
				filters,
				newChecked,
				filterDataArr
			);

			forComparison ? setSelectedCheckBoxItemComparison(newChartFilters) : setSelectedCheckBoxItem(newChartFilters);

			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
		}

		if (type === ADT_TABLE_TYPE.GROUP) {
			let newFilters = _.filter(arrData, ({ filterId }) => {
				return _.every([_.includes(newChecked, filterId)]);
			});
			forComparison ? setPatientDataComparison(newFilters) : setPatientData(newFilters);
			let newChartFilters = _.filter(chartData, ({ filterId }) => {
				return _.every([_.includes(newChecked, filterId)]);
			});
			forComparison ? setSelectedCheckBoxItemComparison(newChartFilters) : setSelectedCheckBoxItem(newChartFilters);
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
		}
		if (type === ADT_TABLE_TYPE.GROUP_ARRAY) {
			let newFilters = await _.filter(arrData, ({ dxIds }) => {
				const matchedIds = _.intersection(newChecked, dxIds);
				if (matchedIds.length > 0) {
					return true;
				} else {
					return false;
				}
			});
			forComparison ? setPatientDataComparison(newFilters) : setPatientData(newFilters);
			let newChartFilters = await _.filter(chartData, ({ dxIds }) => {
				const matchedIds = _.intersection(newChecked, dxIds);
				if (matchedIds.length > 0) {
					return true;
				} else {
					return false;
				}
			});
			forComparison ? setSelectedCheckBoxItemComparison(newChartFilters) : setSelectedCheckBoxItem(newChartFilters);
			await updateChartArrData(newChartFilters, latestButtonFilterType, "filter", filterObj, forComparison);
		}

		if (type === "all") {
			forComparison ? setPatientDataComparison(arrData) : setPatientData(arrData);
			await updateChartArrData(arrData, latestButtonFilterType, "filter", filterObj, forComparison);
		}
	};

	useEffect(() => {
		if (!defaultPatientData.length && !selectedItem.length) return;
		filterOptions(
			selectedItem,
			defaultPatientData,
			defaultChartData,
			buttonFilterType,
			{
				...filters?.filter,
				filterData:
					sidebarFilterDataRef.current?.length > 0
						? sidebarFilterDataRef.current
						: filterData?.length > 0
							? filterData
							: data,
				tableFilterType,
			},
			undefined,
			undefined,
			false
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFacility, isUpdateRefreshMemo]);

	// * added comparison
	const handleToggleAll = useCallback(
		async (value) => {
			if (value == "all") {
				const ids = mapSidebarRowIds(filterData);
				const idsComparison = mapSidebarRowIds(filterDataComparison);

				await Promise.all([
					filterOptions(ids, defaultPatientData, defaultChartData, buttonFilterType, {
						...queryFilters,
						tableFilterType,
					}),
					filterOptions(
						idsComparison,
						defaultPatientDataComparison,
						defaultChartDataComparison,
						buttonFilterType,
						{ ...queryFiltersComparison, tableFilterType },
						undefined,
						undefined,
						true
					),
				]);
				setSelectedItem([...ids]);
				setSelectedItemComparison([...idsComparison]);
			} else {
				setPatientData([]);
				setChartData([]);
				setSelectedCheckBoxItem([]);
				setSelectedItem([]);

				setPatientDataComparison([]);
				setChartDataComparison([]);
				setSelectedCheckBoxItemComparison([]);
				setSelectedItemComparison([]);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			filterData,
			filterDataComparison,
			defaultPatientData,
			defaultChartData,
			buttonFilterType,
			queryFilters,
			defaultPatientDataComparison,
			defaultChartDataComparison,
			buttonFilterType,
			queryFiltersComparison,
		]
	);

	// * added comparison
	const handleToggle = useCallback(
		async (value) => {
			const isCustomDateAnalysisCombineTab =
				filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
				filters?.question?.customTab?.isCustomDateAnalysis;

			const toggledItem = filterData.find(
				(item) => item._id === value || item.id === value || item.key === value
			);
			const isAverageItemToggled = toggledItem ? isAverageItem(toggledItem) : false;

			const currentIndex = selectedItem.indexOf(value);
			let newChecked = [...selectedItem];

			if (currentIndex === -1) {
				if (isCustomDateAnalysisCombineTab && isAverageItemToggled) {
					newChecked = [value];
				} else if (isCustomDateAnalysisCombineTab && !isAverageItemToggled) {
					const averageItems = filterData
						.filter((item) => isAverageItem(item))
						.map((item) => item._id || item.id || item.key);
					newChecked = newChecked.filter((id) => !averageItems.includes(id));
					newChecked.push(value);
				} else {
					newChecked.push(value);
				}
			} else {
				newChecked.splice(currentIndex, 1);
			}

			setSelectedItem(newChecked);
			setSelectedItemComparison(newChecked);

			const filterToggleMain = {
				...queryFilters,
				tableFilterType,
				filterData:
					sidebarFilterDataRef.current?.length > 0
						? sidebarFilterDataRef.current
						: filterData,
			};
			const filterToggleComp = {
				...queryFiltersComparison,
				tableFilterType,
				filterData:
					sidebarFilterDataComparisonRef.current?.length > 0
						? sidebarFilterDataComparisonRef.current
						: filterDataComparison,
			};

			const useFullDatasetForCustomTab =
				filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab ||
				(filters?.question?.isCustomTab &&
					filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.customTab);
			const mainDataSource = useFullDatasetForCustomTab
				? defaultPatientData.length > 0
					? defaultPatientData
					: defaultChartData
				: defaultPatientData;
			const comparisonDataSource = useFullDatasetForCustomTab
				? defaultPatientDataComparison.length > 0
					? defaultPatientDataComparison
					: defaultChartDataComparison
				: defaultPatientDataComparison;

			if (newChecked.length > 0) {
				await Promise.all([
					filterOptions(
						newChecked,
						mainDataSource,
						defaultChartData,
						buttonFilterType,
						filterToggleMain
					),
					filterOptions(
						newChecked,
						comparisonDataSource,
						defaultChartDataComparison,
						buttonFilterType,
						filterToggleComp,
						undefined,
						undefined,
						true
					),
				]);
			} else {
				setPatientData([]);
				setChartData([]);
				setSelectedCheckBoxItem([]);
				setPatientDataComparison([]);
				setChartDataComparison([]);
				setSelectedCheckBoxItemComparison([]);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			selectedItem,
			defaultPatientData,
			defaultChartData,
			buttonFilterType,
			queryFilters,
			defaultPatientDataComparison,
			defaultChartDataComparison,
			queryFiltersComparison,
			filterData,
			filters?.question?.customTab?.type,
			filters?.question?.customTab?.isCustomDateAnalysis,
			tableFilterType,
		]
	);

	// * added comparison
	const reloadChartData = useCallback(
		async (startDate, endDate, startDateComparison, endDateComparison) => {
			const currentRequest = _.uniqueId();
			activeRequestRef.current = currentRequest;
			try {
				setLoading(true);
				let filterObj = { ...filters, filter: { startDate, endDate } };
				let filterObjComparison = {
					...filtersComparison,
					filter: { startDate: startDateComparison, endDate: endDateComparison },
				};

				let latestButtonFilterType = buttonFilterType;
				const isUpdateFilter = isUpdateDefaultFilter(filterObj.filter);
				if (isUpdateFilter) {
					setSelectedFilter(FILTER_TYPES.WEEKLY);
					latestButtonFilterType = CHART_FILTER_DAY_OF.WEEK;
					setButtonFilterType(CHART_FILTER_DAY_OF.WEEK);
				}

				const fetchPromises = [];
				fetchPromises.push(cardADTPatientChartData({ ...filterObj }, "main"));

				if (filterObjComparison) {
					fetchPromises.push(cardADTPatientChartData({ ...filterObjComparison }, "comparison"));
				} else {
					fetchPromises.push(Promise.resolve(null));
				}

				const [response, responseComparison] = await Promise.all(fetchPromises);

				if (activeRequestRef.current !== currentRequest) return;

				if (response && response.data && response.data.list.length > 0) {
					const adtPageTypeReload =
						filterObj?.type?.parentId ||
						filterObj?.selectedCardItem?.parentId ||
						PAGE_TYPE.ADMISSION;
					const chartResponseMain = buildChartResponseFromAdtApi(response, filterObj);
					const filteredMain = await filterPatientDataByLevel({
						response: chartResponseMain,
						filters: filterObj,
						pageType: adtPageTypeReload,
					});
					const listData = filteredMain?.data ?? chartResponseMain.data ?? [];
					setDbAdmissionTotal(response.admissionTotal);
					setDefaultChartData(listData);
					setDefaultPatientData(listData);
					if (response.censusByFacility) {
						setCensusByFacility(response?.censusByFacility || []);
					}
					if (response.bedCapacityByFacility) {
						setBedCapacityByFacility(response.bedCapacityByFacility);
					}
					const chartDataArr = await chartsData(listData, filterObj.filter);
					const latestChartData = await chartGroupBy(
						chartDataArr,
						latestButtonFilterType,
						response.data.admissionTotal,
						[],
						queryFilters
					);

					if (
						filters.selectedCardItem.childId == "90Days" ||
						filters.selectedCardItem.childId === "60Days" ||
						filters.selectedCardItem.childId === "90DaysDeceased" ||
						filters.selectedCardItem.childId === "90DaysOverall"
					) {
						let originalChartData = [];
						if (response.data && response.data.ninetyDaysData && response.data.ninetyDaysData.length > 0) {
							originalChartData = response.data.ninetyDaysData;
						}
						if (
							response.data &&
							response.data.deceasedNinetyDaysChartCountData &&
							response.data.deceasedNinetyDaysChartCountData.length > 0
						) {
							originalChartData = response.data.deceasedNinetyDaysChartCountData;
						}
						if (
							response.data &&
							response.data.overAllNinetyDaysChartCountData &&
							response.data.overAllNinetyDaysChartCountData.length > 0
						) {
							originalChartData = response.data.overAllNinetyDaysChartCountData;
						}
						if (response.data && response.data.sixtyDaysData && response.data.sixtyDaysData.length > 0) {
							originalChartData = response.data.sixtyDaysData;
						}
						if (filterData.length > 0 && originalChartData.length > 0) {
							const latestFilterData = filterData
								.map((eleFilter) => {
									const selectedEle = _.find(originalChartData, { _id: eleFilter._id });
									if (selectedEle) {
										return {
											...eleFilter,
											admissionIds: selectedEle.admissionIds,
											ids: selectedEle.ids,
											patientIds: selectedEle.ids,
										};
									} else {
										return null;
									}
								})
								.filter((item) => item);
							setFilterData(latestFilterData);
						} else {
							setFilterData(filterData);
						}
					}
					if (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
						const mainPayload = response?.data ?? response;
						const combineRaw = mainPayload?.customCombineTabData;
						if (Array.isArray(combineRaw) && combineRaw.length > 0) {
							const combineTabData = combineRaw[0];
							combineTabDataRef.current = combineTabData;
							if (
								filters?.question?.customTab?.isCustomDateAnalysis &&
								combineTabData?.customDataArray &&
								Array.isArray(combineTabData.customDataArray) &&
								combineTabData.customDataArray.length > 0
							) {
								customDataArrayRef.current = combineTabData.customDataArray;
								setFilterData(combineTabData.customDataArray);
							} else if (combineTabData?.totalByPage) {
								const tbd = Object.keys(combineTabData.totalByPage).map((key) => {
									const pageData = combineTabData.totalByPage[key];
									const rawLabel = pageData.label || pageData.dashboard || key;
									const capitalizedLabel = capitalizeFirstLetter(rawLabel);
									return {
										_id: key,
										id: key,
										label: capitalizedLabel,
										name: capitalizedLabel,
										total: pageData.total || 0,
										value: pageData.total || 0,
										percentage: pageData.percentage || "0.0",
										patientIds: pageData.patientIds || [],
										dashboard: pageData.dashboard,
										originalTotal: pageData.total || 0,
										isTooltip: false,
									};
								});
								setFilterData(tbd);
							}
						}
					}
					setSelectedCheckBoxItem(listData);
					setChartData(latestChartData);
					if (selectedItem.length > 0) {
						await filterOptions(
							selectedItem,
							listData,
							listData,
							latestButtonFilterType,
							{
								...filterObj.filter,
								tableFilterType,
								filterData:
									sidebarFilterDataRef.current?.length > 0
										? sidebarFilterDataRef.current
										: filterData,
							},
							"reload",
							response.data
						);
					} else if (
						!filters?.question?.isCustomTab &&
						filters?.question?.customTab?.type !== CUSTOM_TAB_TYPE.combineTab
					) {
						setPatientData(listData);
					}
				}

				if (
					responseComparison &&
					responseComparison.data &&
					responseComparison.data.list.length > 0
				) {
					const adtPageTypeReloadComp =
						filterObjComparison?.type?.parentId ||
						filterObjComparison?.selectedCardItem?.parentId ||
						PAGE_TYPE.ADMISSION;
					const chartResponseComparison = buildChartResponseFromAdtApi(
						responseComparison,
						filterObjComparison
					);
					const filteredComparisonReload = await filterPatientDataByLevel({
						responseComparison: chartResponseComparison,
						filters: filterObjComparison,
						pageType: adtPageTypeReloadComp,
						forComparison: true,
					});
					const listDataComparison =
						filteredComparisonReload?.data ?? chartResponseComparison.data ?? [];
					setDbAdmissionTotalComparison(responseComparison.admissionTotal);
					setDefaultChartDataComparison(listDataComparison);
					setDefaultPatientDataComparison(listDataComparison);
					if (responseComparison.censusByFacility) {
						setCensusByFacilityComparison(responseComparison?.censusByFacility || []);
					}
					if (responseComparison.bedCapacityByFacility) {
						setBedCapacityByFacilityComparison(responseComparison.bedCapacityByFacility);
					}
					const chartDataArrComparison = await chartsData(listDataComparison, filterObjComparison.filter);
					const latestChartDataComparison = await chartGroupBy(
						chartDataArrComparison,
						latestButtonFilterType,
						responseComparison.data.admissionTotal,
						[],
						queryFiltersComparison
					);

					if (
						filtersComparison?.selectedCardItem.childId == "90Days" ||
						filtersComparison?.selectedCardItem.childId === "60Days" ||
						filtersComparison?.selectedCardItem.childId === "90DaysDeceased" ||
						filtersComparison?.selectedCardItem.childId === "90DaysOverall"
					) {
						let originalChartDataComparison = [];
						if (
							responseComparison.data &&
							responseComparison.data.ninetyDaysData &&
							responseComparison.data.ninetyDaysData.length > 0
						) {
							originalChartDataComparison = responseComparison.data.ninetyDaysData;
						}
						if (
							responseComparison.data &&
							responseComparison.data.deceasedNinetyDaysChartCountData &&
							responseComparison.data.deceasedNinetyDaysChartCountData.length > 0
						) {
							originalChartDataComparison = responseComparison.data.deceasedNinetyDaysChartCountData;
						}
						if (
							responseComparison.data &&
							responseComparison.data.overAllNinetyDaysChartCountData &&
							responseComparison.data.overAllNinetyDaysChartCountData.length > 0
						) {
							originalChartDataComparison = responseComparison.data.overAllNinetyDaysChartCountData;
						}
						if (
							responseComparison.data &&
							responseComparison.data.sixtyDaysData &&
							responseComparison.data.sixtyDaysData.length > 0
						) {
							originalChartDataComparison = responseComparison.data.sixtyDaysData;
						}
						if (filterDataComparison.length > 0 && originalChartDataComparison.length > 0) {
							const latestFilterDataComparison = filterDataComparison
								.map((eleFilter) => {
									const selectedEle = _.find(originalChartDataComparison, { _id: eleFilter._id });
									if (selectedEle) {
										return {
											...eleFilter,
											admissionIds: selectedEle.admissionIds,
											ids: selectedEle.ids,
											patientIds: selectedEle.ids,
										};
									} else {
										return null;
									}
								})
								.filter((item) => item);
							setFilterDataComparison(latestFilterDataComparison);
						} else {
							setFilterDataComparison(filterDataComparison);
						}
					}
					if (filtersComparison?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
						const compPayload = responseComparison?.data ?? responseComparison;
						const combineRawComp = compPayload?.customCombineTabData;
						if (Array.isArray(combineRawComp) && combineRawComp.length > 0) {
							const c = combineRawComp[0];
							combineTabDataComparisonRef.current = c;
							if (
								filtersComparison?.question?.customTab?.isCustomDateAnalysis &&
								c?.customDataArray &&
								Array.isArray(c.customDataArray) &&
								c.customDataArray.length > 0
							) {
								customDataArrayComparisonRef.current = c.customDataArray;
								setFilterDataComparison(c.customDataArray);
							} else if (c?.totalByPage) {
								const tbd = Object.keys(c.totalByPage).map((key) => {
									const pageData = c.totalByPage[key];
									const rawLabel = pageData.label || pageData.dashboard || key;
									const capitalizedLabel = capitalizeFirstLetter(rawLabel);
									return {
										_id: key,
										id: key,
										label: capitalizedLabel,
										name: capitalizedLabel,
										total: pageData.total || 0,
										value: pageData.total || 0,
										percentage: pageData.percentage || "0.0",
										patientIds: pageData.patientIds || [],
										dashboard: pageData.dashboard,
										originalTotal: pageData.total || 0,
										isTooltip: false,
									};
								});
								setFilterDataComparison(tbd);
							}
						}
					}
					setSelectedCheckBoxItemComparison(listDataComparison);
					setChartDataComparison(latestChartDataComparison);
					if (selectedItem.length > 0) {
						await filterOptions(
							selectedItem,
							listDataComparison,
							listDataComparison,
							latestButtonFilterType,
							{ ...filterObjComparison.filter, tableFilterType },
							"reload",
							responseComparison.data
						);
					}
				}
			} catch {
				// ignore reload errors
			} finally {
				if (activeRequestRef.current === currentRequest) {
					setLoading(false);
				}
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			filters,
			filtersComparison,
			buttonFilterType,
			queryFilters,
			selectedItem,
			filterData,
			queryFiltersComparison,
			filterDataComparison,
			tableFilterType,
		]
	);

	const handleClose = useCallback(() => {
		dispatch(closeADTDetailsDialog());
	}, [dispatch]);

	const handleTabButton = useCallback((type) => {
		setSelectedTab(type);
	}, []);

	const handleClickFilter = useCallback(
		async (type, filterType = null) => {
			setButtonFilterType(filterType);
			setSelectedFilter(type);
			await updateChartArrData(selectedCheckBoxItem, filterType);
		},
		[updateChartArrData, selectedCheckBoxItem]
	);

	const getFieldNames = useCallback(
		(row) => {
			return getAdmissionADTFieldNames(data, row, filters?.relation, filters?.selectedCardItem, filters);
		},
		[data, filters]
	);

	const handleChartLabelType = useCallback(
		async (type) => {
			let latestQueryFilter = { ...queryFilters, chartPointType: type };
			setQueryFilters((prevState) => ({
				...prevState,
				chartPointType: type,
			}));
			let chartDataArr = await chartsData(selectedCheckBoxItem, latestQueryFilter);
			const latestChartData = await chartGroupBy(
				chartDataArr,
				buttonFilterType,
				dbAdmissionTotal,
				[],
				latestQueryFilter
			);
			setChartData(latestChartData);
		},
		[queryFilters, selectedCheckBoxItem, buttonFilterType, dbAdmissionTotal]
	);

	const onClickReport = useCallback(
		(title, automaticallyReport) => {
			handleOnClickReport({
				selectedTab,
				filters,
				chartData: {
					filterData: chartData, filterPatients: patientDataOrderBy(patientData, order, orderBy, {
						getTypeSortLabel: getFieldNames,
					})
				},
				selectedFilter,
				tableElementRef,
				buildingElementRef,
				title: filters?.selectedCardItem?.title + " " + filters?.selectedCardItem?.subTitle,
				queryFilters,
				selectedItem,
				filterData,
				automaticallyReport,
				buttonFilterType,
				orderBy,
				order,
				activeFacilitiesCount: activeFacilities?.length
			});
		},
		[
			patientData,
			handleOnClickReport,
			selectedTab,
			filters,
			chartData,
			selectedFilter,
			queryFilters,
			selectedItem,
			filterData,
			buttonFilterType,
			orderBy,
			order,
			activeFacilities,
			getFieldNames
		]
	);

	const onClickShareReport = useCallback(
		(title) => {
			if (handleOnClickShareReport && filters?.selectedCardItem) {
				// For ADT cards, pass the full item object and Excel data (like in renderADTDataTables)
				handleOnClickShareReport(title, {
					type: filters.selectedCardItem,
					isTotalCard: false,
					useExcel: true,
					excelData: {
						data: patientData,
						filters,
						pageType: DASHBOARD_FILTER_TYPE.ADMISSION,
						getFieldNames,
						title: filters?.selectedCardItem?.subTitle,
						subtitle: filters?.selectedCardItem?.title,
						censusAverage: dbData?.censusAverage || 0,
						bedCapacity: dbData?.bedCapacity || 0,
						questions,
						selectedColumns: [], // Default to empty, user can select columns in share dialog if needed
						orderBy,
						order,
						activeFacilitiesCount: activeFacilities?.length
					}
				});
			}
		},
		[handleOnClickShareReport, patientData, filters, getFieldNames, dbData, questions, orderBy, order, activeFacilities]
	);

	// * added comparison
	useEffect(() => {
		const isFiltersEqual = _.isEqual(filters, prevFiltersRef.current);
		const isFiltersComparisonEqual = _.isEqual(filtersComparison, prevFiltersComparisonRef.current);

		if (isFiltersEqual && isFiltersComparisonEqual) {
			return;
		}

		reset();
		if (filters && filters.filter) {
			const daysFilter = chartFilterPermission(filters.filter);
			const daysDiff = dayDifferent(filters.filter);

			setQueryFilters({
				filterButtons: daysFilter,
				days: daysDiff,
				startDate: filters.filter.startDate,
				endDate: filters.filter.endDate,
				chartPointType: CHART_POINT_TYPE.TOTAL,
			});
		}
		if (filtersComparison && filtersComparison?.filter) {
			const daysFilter = chartFilterPermission(filtersComparison?.filter);
			const daysDiff = dayDifferent(filtersComparison?.filter);

			setQueryFiltersComparison({
				filterButtons: daysFilter,
				days: daysDiff,
				startDate: filtersComparison?.filter.startDate,
				endDate: filtersComparison?.filter.endDate,
				chartPointType: CHART_POINT_TYPE.TOTAL,
			});
		}

		if ((filters && filters.filter) || (filtersComparison && filtersComparison?.filter)) {
			getPatientChartsData();
		}

		prevFiltersRef.current = filters;
		prevFiltersComparisonRef.current = filtersComparison;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filters, filtersComparison]);

	const handleExcelReport = useCallback((selectedColumns = []) => {
		handleGenerateExcelReport({
			data: patientData,
			filters,
			pageType: DASHBOARD_FILTER_TYPE.ADMISSION,
			getFieldNames,
			title: filters?.selectedCardItem?.subTitle,
			subtitle: filters?.selectedCardItem?.title,
			censusAverage: dbData?.censusAverage || 0,
			bedCapacity: dbData?.bedCapacity || 0,
			questions,
			selectedColumns,
			orderBy,
			order,
			activeFacilitiesCount: activeFacilities?.length
		});
	}, [patientData, filters, getFieldNames, handleGenerateExcelReport, dbData, questions, orderBy, order, activeFacilities]);

	const dropDownComponent = () => (
		<AdtTransferViewFilter filters={filters} setOption={setTableFilterType} tableFilterType={tableFilterType} />
	);

	// below code use for search filter in table
	const [searchTerm, setSearchTerm] = useState('');
	const [totalHighlightedCount, setTotalHighlightedCount] = useState(0);
	const [debounceHighlightedCount, setDebounceHighlightedCount] = useState(0);
	const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
	const [highlightedCountDefaultValue, setHighlightedCountDefaultValue] = useState(0);
	const [selectedHighlightedColumns, setSelectedHighlightedColumns] = useState([]);

	// useEffect(() => {
	// 	if (questions && questions.length > 0) {
	// 		setSelectedHighlightedColumns([...questions?.map((ele) => ele?.question?.accessor), ...tableDefaultQuestions.map((ele) => ele?.question?.accessor), "selectAll"]);
	// 	}
	// }, [questions]);

	const [filterType, setFilterType] = useState({ type: '', filter: '', operation: '' });

	useEffect(() => {
		const handlerCount = _.debounce(() => setDebounceHighlightedCount(totalHighlightedCount), 200);
		handlerCount();
		return () => handlerCount.cancel();
	}, [totalHighlightedCount]);

	useEffect(() => {
		const handler = _.debounce(() => {
			setDebouncedSearchTerm(searchTerm);
			setFilterType({ type: typeof searchTerm, filter: searchTerm, operation: '' });
		}, 150);
		handler();
		return () => handler.cancel();
	}, [searchTerm]);

	const handleSearch = (event) => {
		const value = event.target.value;
		setSearchTerm(isNaN(value) || !value ? value : Number(value));
	};

	const handleHighlightedCount = useCallback((count) => {
		setTotalHighlightedCount(searchTerm ? count : 0);
	}, [searchTerm]);

	const headerFilterOptions = () => {
		return <Grid
			direction={"row"}
			justifyContent={"flex-start"}
			display={"flex"}
			justifyItems={"flex-start"}
			alignItems="center"
		>
			<Grid item>
				<AdmissionHeaderFilterList
					filterListData={filters?.filterListData}
					cardFilter={cardFilter}
					transferType={filters?.transferType}
					openFrom="detailView"
					percentageBy={percentageBy}
					lockedTotal={lockedTotal}
					lockedTotalBy={lockedTotalBy}
					lockeByADT={lockeByADT}
				/>
			</Grid>
		</Grid>
	}

	// Mobile sidebar toggle function
	const handleSidebarToggle = useCallback(() => {
		setIsSidebarExpanded(prev => !prev);
	}, []);

	const mainContentSx = {
		display: "flex",
		flexDirection: "column",
		flex: 1,
		minWidth: 0,
		minHeight: 0,
		height: "100%",
		transition: "all 0.3s ease-in-out",
		px: { xs: 0.75, sm: 3 },
		py: { xs: 0, sm: 2.5 },
		gap: { xs: 0.5, sm: 2 },
		...(isMobile && !isSidebarExpanded && { marginLeft: "4px" }),
		...(isMobile && {
			overflowY: "hidden",
		}),
	};

	const tableContentStackSx = {
		flex: 1,
		minHeight: 0,
		width: "100%",
		maxWidth: "100%",
		mt: { xs: 0, sm: 1 },
		overflow: "hidden",
		"& > *": {
			flex: 1,
			minWidth: 0,
			minHeight: 0,
			height: "100%",
		},
	};

	return (
		<ChartDialogContainer
			handleClose={handleClose}
			isOpen={isOpen}
			isMobile={isMobile}
			maxWidth={false}
			paperSx={
				isMobile
					? undefined
					: {
							width: "min(96vw, 1880px)",
							maxWidth: "min(96vw, 1880px)",
							margin: "16px auto",
						}
			}
		>
			{isMobile && !isSidebarExpanded && (
				<Grid
					item
					sx={{
						width: '4px',
						height: '100vh',
						backgroundColor: '#1976d2',
						transition: 'all 0.3s ease-in-out',
						position: 'relative',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						'&:hover': {
							width: '8px',
							backgroundColor: '#1565c0'
						}
					}}
				>
					<Box
						onClick={handleSidebarToggle}
						sx={{
							position: 'absolute',
							left: '250%',
							top: '10%',
							transform: 'translate(-50%, -50%)',
							backgroundColor: 'rgba(255, 255, 255, 0.9)',
							borderRadius: '50%',
							width: '20px',
							height: '20px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							border: '1px solid rgba(0, 0, 0, 0.1)',
							boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
							cursor: 'pointer',
							zIndex: 1000,
							'&:hover': {
								backgroundColor: 'rgba(255, 255, 255, 1)',
								transform: 'translate(-50%, -50%) scale(1.1)'
							}
						}}
					>
						<KeyboardArrowRightIcon
							sx={{ fontSize: 12, color: '#1976d2' }}
						/>
					</Box>
				</Grid>
			)}
			{isMobile && (
				<ChartDialogLeftSidebar
					loading={loading}
					filterData={filterData}
					selectedItem={selectedItem}
					handleToggle={handleToggle}
					subtitle={filters?.selectedCardItem?.title}
					title={filters?.selectedCardItem?.subTitle}
					handleToggleAll={handleToggleAll}
					selectedTab={selectedTab}
					isExpanded={isSidebarExpanded}
					onToggleExpand={handleSidebarToggle}
				/>
			)}
			{!isMobile && (
				<ChartDialogLeftSidebar
					loading={loading}
					filterData={filterData}
					selectedItem={selectedItem}
					handleToggle={handleToggle}
					subtitle={filters?.selectedCardItem?.title}
					title={filters?.selectedCardItem?.subTitle}
					handleToggleAll={handleToggleAll}
					selectedTab={selectedTab}
					isExpanded={isSidebarExpanded}
					onToggleExpand={handleSidebarToggle}
				/>
			)}
			<Grid
				item
				xs={isMobile ? (isSidebarExpanded ? 7.5 : 11.8) : 10.7}
				sm={isMobile ? (isSidebarExpanded ? 7.5 : 11.8) : 10.7}
				sx={mainContentSx}
			>
				<ChartDetailsTab
					selectedTab={selectedTab}
					handleTabButton={handleTabButton}
					queryFilters={queryFilters}
					handleOnClickReport={onClickReport}
					handleOnClickShareReport={onClickShareReport}
					loading={loading}
					handleExcelReport={handleExcelReport}
					{...(selectedTab === CHART_TAB_BUTTON.TABLE &&
						filters?.question?.customTab?.type !== CUSTOM_TAB_TYPE.combineTab && {
							tableFilterTypeOptions: dropDownComponent(),
						})}
					setSelectedFacility={setSelectedFacility}
					selectedFacility={selectedFacility}
					questions={questions}
					pageType={filters?.selectedCardItem?.parentId}
					subPageType={PAGE_TYPE.ADT}
					tableFilterType={
						filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab
							? "all"
							: filters?.type?.parentId === "hospital"
								? filters.type.parentId
								: tableFilterType
					}
					filterHeaderContainer={() => headerFilterOptions()}
					isMobile={isMobile}
				/>

				{selectedTab === CHART_TAB_BUTTON.TABLE && (
					<>
						<Divider sx={{ borderColor: "divider", opacity: 0.8 }} />
						<ChartDetailsSearchBar
							searchTerm={searchTerm}
							handleSearch={handleSearch}
							setSearchTerm={setSearchTerm}
							highlightedCount={debounceHighlightedCount}
							filterType={filterType}
							setFilterType={setFilterType}
							selectedHighlightedColumns={selectedHighlightedColumns}
							setSelectedHighlightedColumns={setSelectedHighlightedColumns}
							selectedQuestions={questions}
							isSelectColumn={filters?.question?.customTab?.type !== CUSTOM_TAB_TYPE.combineTab}
							selectedTab={selectedTab}
							isMobile={isMobile}
						/>
					</>
				)}

				{!loading && (
					<Box
						sx={{
							flex: 1,
							minHeight: 0,
							display: "flex",
							flexDirection: "column",
							overflow: selectedTab === CHART_TAB_BUTTON.TABLE ? "hidden" : "visible",
						}}
					>
					<NoteContainer page={PAGE_TYPE.ADMISSION} openFrom="dialog" isMobile={isMobile}>
						{selectedTab === CHART_TAB_BUTTON.BUILDING && (
							<Stack direction={"row"} sx={{ mt: 2, height: "99%" }}>
								<ChartBuildingList
									data={patientData}
									page={filters?.type?.parentId}
									relation={filters?.relation}
									getFieldNames={getFieldNames}
									chartData={{ mainData: patientData }}
									censusByFacility={filters.filterTotalByTransferType}
									bedCapacityByFacility={bedCapacityByFacility}
									facilityPerText="Default % is against total admissions and not Avg. Occupancy"
									filterSelected={filters.filterSelected || filters.transferType != null}
									adtFacilityPercentage={filters.adtFacilityPercentage}
									filter={filters}
									buildingElementRef={buildingElementRef}
									dataComparison={patientDataComparison}
									relationComparison={filtersComparison?.relation}
									chartDataComparison={{ mainData: patientDataComparison }}
									censusByFacilityComparison={filtersComparison?.filterTotalByTransferType}
									bedCapacityByFacilityComparison={bedCapacityByFacilityComparison}
									filterSelectedComparison={filtersComparison?.filterSelected}
									filterComparison={filtersComparison}
									isAdt={true}
									filterListData={filters?.filterListData}
									selectedADTTableData={filters?.selectedADTTableData}
									typeCard={filters?.type}
								/>
							</Stack>
						)}
						{selectedTab === CHART_TAB_BUTTON.TABLE && (
							<Stack direction={"row"} sx={tableContentStackSx}>
								<ChartTableList
									isAdt={true}
									data={patientData}
									relation={filters?.relation}
									getFieldNames={getFieldNames}
									filters={{ ...filters, cardTitle: filters?.selectedCardItem?.subTitle }}
									pageType={filters.selectedCardItem.parentId == "hospital" ? DASHBOARD_FILTER_TYPE.HOSPITAL : null}
									tableElementRef={tableElementRef}
									questions={questions}									
									searchTerm={debouncedSearchTerm}
									handleHighlightedCount={handleHighlightedCount}
									highlightedCountDefaultValue={highlightedCountDefaultValue}
									filterType={filterType}
									selectedHighlightedColumns={selectedHighlightedColumns}
									isNotCombineTab={filters?.question?.customTab?.type !== CUSTOM_TAB_TYPE.combineTab}
									orderData={{
										orderBy,
										setOrderBy,
										order,
										setOrder
									}}
									activeFacilities={activeFacilities}
									tableFilterType={
										filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab ? "all" : tableFilterType
									}
								/>
							</Stack>
						)}
						{selectedTab === CHART_TAB_BUTTON.CHART && (
							<Stack direction={"row"} sx={{ mt: isMobile ? 1 : 2, height: isMobile ? "auto" : "90%" }}>
								<CardDetailChart
									totalText="Total Admissions Transfer"
									data={chartData}
									filters={filters}
									censusAverage={null}
									total={patientData.length || 0}
									setQueryFilters={setQueryFilters}
									queryFilters={queryFilters}
									handleClickFilter={handleClickFilter}
									selectedFilter={selectedFilter}
									reloadChartData={reloadChartData}
									isChartTotalButton={true}
									handleChartLabelType={handleChartLabelType}
									selectedFacility={selectedFacility}
									dbData={dbData}
									isMobile={isMobile}
								/>
							</Stack>
						)}
					</NoteContainer>
					</Box>
				)}
				<ChartTabLoader loading={loading} />
			</Grid>
		</ChartDialogContainer>
	);
}
